import type SVGType from 'types/svg.types';

const TopStatusIcon: SVGType = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_595_3238)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2573 5.13605L16.5909 3.46968C15.7123 2.591 14.2876 2.591 13.409 3.46968L11.7426 5.13605H9.38599C8.14335 5.13605 7.13599 6.14341 7.13599 7.38605V9.74265L5.46962 11.409C4.59094 12.2877 4.59094 13.7123 5.46962 14.591L7.13599 16.2574V18.614C7.13599 19.8566 8.14334 20.864 9.38599 20.864H11.7426L13.409 22.5303C14.2876 23.409 15.7123 23.409 16.5909 22.5303L18.2573 20.864H20.6139C21.8566 20.864 22.8639 19.8566 22.8639 18.614V16.2574L24.5303 14.591C25.409 13.7123 25.409 12.2877 24.5303 11.409L22.8639 9.74265V7.38605C22.8639 6.14341 21.8566 5.13605 20.6139 5.13605H18.2573ZM17.4163 6.41638C17.557 6.55703 17.7477 6.63605 17.9466 6.63605H20.6139C21.0281 6.63605 21.3639 6.97183 21.3639 7.38605V10.0533C21.3639 10.2522 21.4429 10.443 21.5836 10.5836L23.4696 12.4697C23.7625 12.7626 23.7625 13.2374 23.4696 13.5303L21.5836 15.4164C21.4429 15.557 21.3639 15.7478 21.3639 15.9467V18.614C21.3639 19.0282 21.0281 19.364 20.6139 19.364H17.9466C17.7477 19.364 17.557 19.443 17.4163 19.5836L15.5303 21.4697C15.2374 21.7626 14.7625 21.7626 14.4696 21.4697L12.5836 19.5836C12.4429 19.443 12.2522 19.364 12.0532 19.364H9.38599C8.97177 19.364 8.63599 19.0282 8.63599 18.614V15.9467C8.63599 15.7478 8.55697 15.557 8.41632 15.4164L6.53028 13.5303C6.23738 13.2374 6.23738 12.7626 6.53028 12.4697L8.41632 10.5836C8.55697 10.443 8.63599 10.2522 8.63599 10.0533V7.38605C8.63599 6.97183 8.97177 6.63605 9.38599 6.63605H12.0532C12.2522 6.63605 12.4429 6.55703 12.5836 6.41638L14.4696 4.53034C14.7625 4.23745 15.2374 4.23745 15.5303 4.53034L17.4163 6.41638Z"
        fill="currentColor"
      />
      <path
        d="M17.9466 6.63593C17.7477 6.63593 17.5569 6.55691 17.4163 6.41626L15.5302 4.53022C15.2373 4.23732 14.7625 4.23732 14.4696 4.53022L12.5835 6.41626C12.4429 6.55691 12.2521 6.63593 12.0532 6.63593H9.38593C8.97171 6.63593 8.63593 6.97171 8.63593 7.38593V10.0532C8.63593 10.2521 8.55691 10.4429 8.41626 10.5835L6.53022 12.4696C6.23732 12.7625 6.23732 13.2373 6.53022 13.5302L8.41626 15.4163C8.55691 15.5569 8.63593 15.7477 8.63593 15.9466V18.6138C8.63593 19.0281 8.97171 19.3638 9.38593 19.3638H12.0532C12.2521 19.3638 12.4429 19.4429 12.5835 19.5835L14.4696 21.4696C14.7625 21.7625 15.2373 21.7625 15.5302 21.4696L17.4163 19.5835C17.5569 19.4429 17.7477 19.3638 17.9466 19.3638H20.6138C21.0281 19.3638 21.3638 19.0281 21.3638 18.6139V15.9466C21.3638 15.7477 21.4429 15.5569 21.5835 15.4163L23.4696 13.5302C23.7625 13.2373 23.7625 12.7625 23.4696 12.4696L21.5835 10.5835C21.4429 10.4429 21.3638 10.2521 21.3638 10.0532V7.38593C21.3638 6.97171 21.0281 6.63593 20.6139 6.63593H17.9466Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.139 10.7032L14.0617 15.9837C13.9534 16.0963 13.8031 16.1588 13.6469 16.1562C13.4907 16.1537 13.3426 16.0862 13.2381 15.9701L11.1743 13.677L12.0105 12.9244L13.6698 14.7681L18.3281 9.92346L19.139 10.7032Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_595_3238"
        x="-1"
        y="-1"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_595_3238"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_595_3238"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default TopStatusIcon;
